import { BrandColors } from './../../constants/brandColors';
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { useBasicDetails } from '../../store/storeApi';

export const AuthPageStyles = makeStyles((theme: Theme) => {
  const {
    headerDetails: { isICPEnabled },
  } = useBasicDetails();

  return createStyles({
    container: {
      marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.up('lg')]: {
        maxWidth: '864px',
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: '1140px',
      },
    },
    grid: {
      [theme.breakpoints.up('lg')]: {
        padding: '2rem 0',
      },
      [theme.breakpoints.up('xl')]: {
        padding: '5rem 0',
      },
    },
    paper: {
      padding: '2rem 1.5rem 2.5rem 1.5rem',

      // ICP
      [theme.breakpoints.down('sm')]: {
        paddingBottom: isICPEnabled ? '4rem' : '',
      },

      [theme.breakpoints.up('sm')]: {
        padding: '2.5rem 1.5rem',
      },
      [theme.breakpoints.up('md')]: {
        padding: '2.5rem 5rem',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '2rem',
      },
    },
    centerBlock: {
      padding: '1.87rem',
      marginLeft: '-1.87rem',
      marginRight: '-1.87rem',
      [theme.breakpoints.down('md')]: {
        margin: '1.56rem 1.25rem 1.25rem 1.25rem',
        height: 'calc(100vh - 85px)',
      },
    },
    forgotPasswordPaper: {
      padding: '2rem 1.5rem 2.5rem 1.5rem',
      [theme.breakpoints.up('sm')]: {
        padding: '2.5rem 1.5rem',
      },
      [theme.breakpoints.up('md')]: {
        padding: '2.5rem 5rem 5rem',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '2rem',
      },
    },
    buttonProgress: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: '25%',
      left: '40%',
    },
    progressMeterAlert: {
      marginTop: '0.5rem',
    },
    passwordContainer: {
      caretColor: 'black',
      fontFamily: 'monospace',
      fontSize: '1rem',
      position: 'relative',
      overflow: 'hidden',
      '& input': {
        color: 'transparent',
        fontFamily: 'monospace',
        '@media screen and (-ms-high-contrast: none)': {
          paddingRight: '0rem',
        },
      },
      '& input::placeholder': {
        fontFamily: "'Open Sans', sans-serif",
      },
      '& :-ms-input-placeholder': {
        fontFamily: "'Open Sans', sans-serif",
      },
      '& input::selection': {
        color: 'transparent',
        background: BrandColors.selectionColor,
      },
      '&:after': {
        position: 'absolute',
        top: '.75rem',
        left: '1.1875rem',
        pointerEvents: 'none',
        width: 'calc(100% - 2.5rem)',
        overflow: 'hidden',
      },
    },
    padding12: {
      '& p, h2': {
        padding: '0.75rem',
      },
    },
    resetPassword: {
      marginTop: '0 !important',
      maxHeight: 'calc(100vh - 240px)',
      paddingRight: '0 !important',
      marginBottom: '1rem',
      [theme.breakpoints.up('md')]: {
        maxHeight: 'calc(100vh - 250px)',
      },
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 345px)',
      },
    },
    userProfileSetting: {
      maxHeight: 'calc(100vh - 375px)',
      marginRight: '0px',
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 515px)',
        marginRight: '-12px',
      },
    },
    signUp: {
      paddingBottom: '12px !important',
      marginTop: '0 !important',
      maxHeight: 'calc(100vh - 380px)',
      [theme.breakpoints.up('md')]: {
        maxHeight: 'calc(100vh - 390px)',
      },
      [theme.breakpoints.up('lg')]: {
        maxHeight: 'calc(100vh - 550px)',
        paddingBottom: '40px !important',
        minHeight: '250px',
      },
    },
    ssoConfirmStyle: {
      paddingRight: '0rem',
      maxHeight: 'calc(100vh - 340px)',
      [theme.breakpoints.up('md')]: {
        maxHeight: 'calc(100vh - 400px)',
      },
      [theme.breakpoints.up('lg')]: {
        paddingRight: '1rem',
        maxHeight: 'calc(100vh - 490px)',
      },
    },
  });
});
